import React from 'react'
import styled, { css } from 'styled-components'
import _Stripes_animation from 'components/Stripes/_Stripes_animation'

const animation_time = 3.1415926535

export const StyledComponent = styled(
  ({loading, size, ...other_props}) => (<div {...other_props} />))`
   overflow: hidden;
  >hr {
    height: ${p => p.size * 5}px;
    border: none;
    margin: 0 0 ${p => p.size * 2}px 0;
    ${p => p.loading && css`
      animation: ${_Stripes_animation} ${animation_time}s linear infinite;
      transform: translateX(-101%);
    `};


    &:nth-child(1){
      color: ${props => props.theme.cDarkBlue};
      background-color: ${props => props.theme.cDarkBlue};
    }

    &:nth-child(2){
      color: ${props => props.theme.cDarkRed};
      background-color: ${props => props.theme.cDarkRed};
      animation-delay: ${animation_time * 0.1}s;
    }

    &:nth-child(3){
      color: ${props => props.theme.cOrange};
      background-color: ${props => props.theme.cOrange};
      animation-delay: ${animation_time * 0.15}s;
    }

    &:nth-child(4){
      color: ${props => props.theme.cLightBlue};
      background-color: ${props => props.theme.cLightBlue};
      animation-delay: ${animation_time * 0.2}s;
    }
  }
`
const _Stripes_Styled = (props) => <StyledComponent {...props} />
_Stripes_Styled.propTypes = {}
_Stripes_Styled.className = StyledComponent
export default _Stripes_Styled
